import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { ConfirmData } from '@core/modules/dialogs/models/confirm-data.interface';

@Component({
    standalone: false,
    selector: 'noa-dialog-confirm',
    template: `
        <div class="noa-dialog">
            <h1 *ngIf="data.title" class="text-center mb-1" matDialogTitle>{{ data.title }}</h1>
            <div mat-dialog-content class="text-center mb-1">
                <div *ngIf="data.htmlMessage" [innerHTML]="data.htmlMessage | sanitize: 'html'"></div>
                <p *ngIf="!data.htmlMessage" class="dialog-message">{{ data.message }}</p>
                <mat-divider *ngIf="data.extendedMessage" class="mb-3"></mat-divider>
                <p *ngIf="data.extendedMessage" class="dialog-extended-message">{{ data.extendedMessage }}</p>
            </div>
            <mat-divider class="mb-3"></mat-divider>
            <div class="actions">
                <ng-container *ngFor="let button of data.buttons">
                    <button
                        class="noa-button-link"
                        [ngClass]="{ 'btn-primary': button.primary }"
                        (click)="dialogRef.close(button.value)"
                        type="button"
                    >
                        {{ button.label }}
                    </button>
                </ng-container>
            </div>
        </div>
    `,
    styles: [
        `
            .dialog-message {
                font-size: 15px;
            }

            .dialog-extended-message {
                font-size: 13px;
            }
        `,
    ],
})
export class DialogMultiOptionComponent {
    constructor(public dialogRef: MatDialogRef<DialogMultiOptionComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmData) {}
}
